// extracted by mini-css-extract-plugin
module.exports = {"root":"IconEnquiry_root__1v_JK","marketplaceColorStroke":"IconEnquiry_marketplaceColorStroke__1ETvu"};